module.exports = __webpack_public_path__ + "img/megan-giddings.cf60e4ea.png";